import axios from 'axios';
import React, { Component } from 'react';
import { Dialog, DialogContent, DialogActions, Toolbar, Typography, CircularProgress, Select, MenuItem, FormControl, InputLabel } from '@material-ui/core';
import DownloadButton from '../general/download_button.js';
import Config from '../config.js';
import {parse} from 'csv-parse/lib/sync';
import {stringify} from 'csv-stringify/lib/sync';
import FileSaver from 'filesaver.js-npm';
import Image from '../general/image.js';
import isEqual from 'lodash.isequal';
import PDFMerger from 'pdf-merger-js/browser';
import ExtendedSelect from '../general/select.js';

const lbKey = 'Identifier.LogicbrokerKey';
const trackingNumber = 'ShipmentInfo.TrackingNumber';
const quantity = 'OrderLine.Quantity';
const description = 'OrderLine.Description';
const classCode = 'ShipmentInfo.ClassCode';
const senderClassCode = 'ShipmentInfo.SenderClassCode';
const supplierSku = 'OrderLine.ItemIdentifier.SupplierSKU';
const partnerSku = 'OrderLine.ItemIdentifier.PartnerSKU';
const shipToState = 'ShipToAddress.State';
const arrivalType = 'ExtendedAttribute[Name=Arrival Type].Value';
const requestedDelivery = 'ExtendedAttribute[Name=Requested Delivery].Value';
const requestedShipDate = 'RequestedShipDate';
const columns = [lbKey, 'PartnerPO', 'OrderNumber', requestedShipDate, classCode, senderClassCode, trackingNumber, supplierSku, partnerSku, quantity, description, shipToState, arrivalType, requestedDelivery];

class BulkPick extends Component {
    state = {loaded: false, fileName: '', showModal: false, showError: false, error: '', orders: [], trackedOrderCount: 0, 
    filterSku: [], filterPartnerSku: [], filterShipDate: [], sort: [supplierSku, senderClassCode, shipToState],
    skus: [], shipDates: [], partnerSkus: []};
    loadOrders = async () => {
        await this.setState({loaded: false});
        let orderStatus = 500;
        let req = {
            Columns: columns.map(r => ({SourceField: r, TargetField: r})),
            Delimiter: ',',
            FileType: 'csv',
            Filter: {
                advanced: `StatusCode eq ${orderStatus}`
            }
        };
        let exportLink = (await axios.post(Config.api + '/api/v2/orders/export', req)).data.Body;
        let csv = (await axios.get(exportLink)).data;
        let orders = parse(csv, {columns: true, skip_empty_lines: true});
        let skus = orders.map(r => r[supplierSku]);
        skus = skus.filter((r, i) => skus.indexOf(r) === i).sort();
        let partnerSkus = orders.map(r => r[partnerSku]);
        partnerSkus = partnerSkus.filter((r, i) => !(!r) && partnerSkus.indexOf(r) === i).sort();
        let shipDates = orders.map(r => r[requestedShipDate]);
        shipDates = shipDates.filter((r, i) => !(!r) && shipDates.indexOf(r) === i).sort();
        let orderIds = this.getUniqueIds(orders);
        let imageUrl = null;
        if(orderIds.length > 0){
            imageUrl = (await axios.get(Config.api + `/api/v1/orders/${orderIds[0]}/picklist?filetype=png`)).data.Body;
        }
        this.setState({showModal: true, orders, loadedOrders: orders.length > 0,
            imageUrl, fileName: new Date().getTime().toString() + '-picklist.pdf', shipDates, skus, partnerSkus});
    }
    isFiltered = () => {
        return this.state.filterSku.length > 0 || this.state.filterShipDate.length > 0 || this.state.filterPartnerSku.length > 0;
    }
    filterOrders = orders => {
        if(this.state.filterSku.length > 0){
            orders = orders.filter(r => this.state.filterSku.filter(x => r[supplierSku] === x).length > 0);
        }
        if(this.state.filterPartnerSku.length > 0){
            orders = orders.filter(r => this.state.filterSku.filter(x => r[partnerSku] === x).length > 0);
        }
        if(this.state.filterShipDate.length > 0){
            orders = orders.filter(r => this.state.filterShipDate.filter(x => r[requestedShipDate] === x).length > 0);
        }
        return orders;
    }
    getUniqueIds = orders => {
        orders = this.filterOrders(orders);
        let orderIds = orders.map(r => r[lbKey]);
        orderIds = orderIds.filter((r, i) => orderIds.indexOf(r) === i);
        return orderIds;
    }
    getUniqueIdsWithTracking = orders => {
        orders = this.filterOrders(orders);
        orders = orders.filter(r => !(!r[trackingNumber]));
        return this.getUniqueIds(orders);
    }
    downloadPickList = async (updateStatus, setProgress) => {
        // sort
        let sorted = this.sort(this.state.orders, this.state.sort);
        let orderIds = this.getUniqueIds(sorted);
        let trackedOrderIds = this.getUniqueIdsWithTracking(sorted);
        // break up into pages
        let pageSize = 10;
        let statusPageSize = 50;
        let pickListRequests = Math.ceil(orderIds.length / pageSize);
        let statusRequests = updateStatus ? Math.ceil(trackedOrderIds.length / statusPageSize) : 0;
        let pickListMax = pickListRequests / (pickListRequests + statusRequests) * 100;
        let statusMax = statusRequests / (pickListRequests + statusRequests) * 100;
        let merger = new PDFMerger();
        try{
            for (let i = 0; i < orderIds.length; i += pageSize) {
                let page = orderIds.slice(i, i + pageSize);
                // pass ids to api picklist
                let exportLink = (await axios.get(Config.api + `/api/v1/orders/picklist?LogicbrokerKeys=${page.join(',')}&fileType=pdf`)).data.Body;
                // download pdf
                let res = (await axios({url: exportLink, method: 'GET', responseType: 'blob'})).data;
                await merger.add(res);
                if(setProgress){
                    setProgress((pickListMax / orderIds.length) * (i + page.length));
                }
            }
        } catch {
            this.setState({showError: true, error: `Unexpected error while downloading packing slips. Please try again.`});
            return;
        }
        
        let blob = await merger.saveAsBlob();
        // update tracked orders
        let updated = false;
        if(updateStatus){
            let totalCount = trackedOrderIds.length;
            let updatedCount = 0;
            try{
                while(trackedOrderIds.length > 0){
                    let page = trackedOrderIds.slice(0, statusPageSize);
                    trackedOrderIds = trackedOrderIds.slice(statusPageSize);
                    let req = {
                        "Status": "Shipped",
                        "OnlyIncreaseStatus": true,
                        "LogicbrokerKeys": page
                    };
                    await axios.put(Config.api + '/api/v2/orders/status', req);
                    updatedCount += page.length;
                    if(setProgress){
                        setProgress(pickListMax + (statusMax * (updatedCount / totalCount)));
                    }
                }
                updated = true;
            } catch {
                this.setState({showError: true, error: `Unexpected error while updating status. ${updatedCount} orders were updated. Please try again.`});
            }
        }
        // save blob to disk
        FileSaver.saveAs(blob, this.state.fileName);
        if(updated){
            this.setState({showModal: false});
        }
    }
    group = (data, keySelector) => {
        return data.reduce((acc, val) => {
            let key = keySelector(val);
            let existing = acc.filter(r => isEqual(r.key, key))[0];
            if(!existing){
                acc.push({key, values: [val]});
            } else {
                existing.values.push(val);
            }
            return acc;
        }, []);
    }
    sort = (data, fields) => {
        let sorted = data;
        fields = fields.filter(r => !(!r));
        if(fields.length > 0){
            sorted = data.sort((a, b) => fields.map(r => (a[r] || '').toString().localeCompare((b[r] || '').toString())).filter(r => r !== 0)[0] || 0);
        }
        return sorted;
    }
    downloadCsv = () => {
        let rows = [['SupplierSKU', 'PartnerSKU', 'Description', 'Quantity', 'SenderClassCode', 'Arrival Type', 'Requested Delivery']];
        let sorted = this.sort(this.filterOrders(this.state.orders), this.state.sort);
        let grouped = this.group(sorted, r => ({
            [supplierSku]: r[supplierSku],
            [partnerSku]: r[partnerSku],
            [description]: r[description], 
            [senderClassCode]: r[senderClassCode], 
            [arrivalType]: r[arrivalType],
            [requestedDelivery]: r[requestedDelivery]}));
        let selected = grouped.map(r => [
            r.key[supplierSku],
            r.key[partnerSku],
            r.key[description], 
            r.values.reduce((a, x) => parseInt(x[quantity]) + a, 0), 
            r.key[senderClassCode], 
            r.key[arrivalType],
            r.key[requestedDelivery]]);
        rows = [...rows, ...selected];
        let output = stringify(rows);
        let blob = new Blob([output], { type: "text/csv" });
        FileSaver.saveAs(blob, this.state.fileName.replace('.pdf', '.csv'));
    }
    setSort = (index, value) => {
        let sort = [...this.state.sort];
        sort[index] = value;
        this.setState({sort});
    }
    render(){
        let orderCount = this.getUniqueIds(this.state.orders).length;
        let trackedOrderCount = this.getUniqueIdsWithTracking(this.state.orders).length;
        let progress = <div style={{height: '100%', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}><CircularProgress size={80} variant='indeterminate'/></div>;
        return <>
            <DownloadButton {...this.props} onClick={this.loadOrders}>Bulk Pick</DownloadButton>
            <Dialog open={this.state.showModal} maxWidth='md' fullWidth onClose={() => this.setState({showModal: false})}>
                <Toolbar className='lbtoolbar'>Bulk Pick</Toolbar>
                <DialogContent style={{height: '100%'}}>
                    <Typography style={{marginBottom: '0.5em'}}>Found {orderCount} orders in status Ready to Ship{this.isFiltered() ? ' matching your filters' : ''}. {trackedOrderCount} of them have auto-generated tracking numbers and will be moved to Shipped once you download the packing slips.</Typography>
                    <div style={{display: 'flex',}}>
                        <div className="imagePreview" style={{maxHeight: this.state.loaded ? '1000px': undefined, minHeight: '150px'}}>
                            {this.state.loadedOrders && <Image src={this.state.imageUrl} loadImage={progress} onLoad={() => this.setState({loaded: true})}/>}
                        </div>
                        <div style={{paddingLeft: '20px'}}>
                            <Typography style={{fontWeight: 'bold'}}>Filter by</Typography>
                            <div style={{display: 'flex', flexDirection: 'column', marginBottom: '0.5em'}}>
                                <FormControl style={{paddingTop: '1rem'}}>
                                    <InputLabel shrink={true} htmlFor='SupplierSKU'>Supplier SKU</InputLabel>
                                    <ExtendedSelect displayEmpty style={{width: '26.25rem'}} placeholder='Any' name='SupplierSKU' options={this.state.skus.map(r => ({label: r, value: r}))} value={this.state.filterSku} onChange={v => this.setState({filterSku: v.filter(r => r !== "")})}/>
                                </FormControl>
                                <FormControl style={{paddingTop: '1rem'}}>
                                    <InputLabel shrink={true} htmlFor='PartnerSKU'>Partner SKU</InputLabel>
                                    <ExtendedSelect disabled={!this.state.partnerSkus || this.state.partnerSkus.length === 0} displayEmpty style={{width: '26.25rem'}} placeholder='Any' name='PartnerSKU' options={this.state.partnerSkus.map(r => ({label: r, value: r}))} value={this.state.filterPartnerSku} onChange={v => this.setState({filterPartnerSku: v.filter(r => r !== "")})}/>
                                </FormControl>
                                <FormControl style={{paddingTop: '1rem'}}>
                                    <InputLabel shrink={true} htmlFor='RequestedShipDate'>Requested Ship Date</InputLabel>
                                    <ExtendedSelect displayEmpty placeholder='Any' name='RequestedShipDate' style={{width: '26.25rem'}} options={this.state.shipDates.map(r => ({label: r, value: r}))} value={this.state.filterShipDate} onChange={v => this.setState({filterShipDate: v.filter(r => r !== "")})}/>
                                </FormControl>
                            </div>
                            <Typography style={{fontWeight: 'bold'}}>Sort by</Typography>
                            <div style={{display: 'flex', flexDirection: 'column'}}>
                                {this.state.sort.map((r, i) => <Select placeholder='Select...' style={{width: '26.25rem'}} key={i} value={r} onChange={v => this.setSort(i, v.target.value)}>
                                    <MenuItem value="">Select...</MenuItem>
                                    {columns.sort().map(c => <MenuItem key={c} value={c}>{c}</MenuItem>)}
                                </Select>)}
                            </div>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <DownloadButton disabled={orderCount === 0} onClick={async () => await this.downloadCsv()}>Download picklist</DownloadButton>
                    <DownloadButton disabled={orderCount === 0} onClick={async (setProgress) => await this.downloadPickList(false, setProgress)}>Download preview</DownloadButton>
                    <DownloadButton disabled={orderCount === 0} color='primary' onClick={async (setProgress) => await this.downloadPickList(true, setProgress)}>Download and move to shipped</DownloadButton>
                </DialogActions>
            </Dialog>
            <Dialog open={this.state.showError} onClose={() => {this.setState({showError: false})}}>
                <Toolbar className='lbtoolbar'>Error</Toolbar>
                <DialogContent><Typography>{this.state.error}</Typography></DialogContent>
            </Dialog>
        </>;
    }
}

export default BulkPick;